import React from "react";

const PharmacologicalToolTip = () => {
  return (
    <div className="bg-gray-10 p-2 flex flex-col max-w-[464px] ">
      <p className="text-teal-300 text-left text-body-sm  font-normal">
      Pharmacologic treatment should be combined with non-pharmacologic treatment
      </p>
    </div>
  );
};

export default PharmacologicalToolTip;
